<ng-container *ngIf="filteredPatients.length; else noItems">
    <mat-list>
        <ng-container *ngFor="let group of filteredPatients">
            <div class="list-header">{{group.date | date: 'longDate'}}</div>
            <mat-list-item *ngFor="let patient of group.patients" (click)="navigateToPatientFile(patient.id)"
                class="auto-height">
                <div class="patient-item">
                    <div class="patient-details">
                        <div matLine class="patient-name">
                            <b>{{ patient.surname }}, {{ patient.name }}</b>
                            <span class="patient-number" *ngIf="patient.patientNumber">({{
                                patient.patientNumber }})</span>
                        </div>
                        <div matLine class="patient-diagnosis">
                            <span>{{ patient.diagnosis }}</span>
                        </div>
                        <div matLine class="patient-secondary-diagnosis">
                            <span *ngIf="patient.alertType === 'duplicateBilling'"
                                matTooltip="We have detected multiple notes for this patient for the same date which contain similar codes">Duplicate
                                Coding Detected</span>
                            <span *ngIf="patient.alertType === 'missedBilling'"
                                matTooltip="We have detected that this patient attended a past appointment but there is no coding for the appointment date">Missed
                                Coding Detected</span>
                        </div>
                    </div>
                    <div class="view-icon">
                        <mat-icon>visibility</mat-icon>
                    </div>
                </div>
            </mat-list-item>
        </ng-container>
    </mat-list>
    <div class="mobile-spacer"></div>
</ng-container>

<ng-template #noItems>
    <p class="no-records-message">No coding alerts found.</p>
</ng-template>